import { useRef, useState } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  Grid,
  Paper,
  Divider,
  CircularProgress,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import ReCAPTCHAComponent from "react-google-recaptcha"; // Renamed to avoid warning
import { Send as SendIcon } from "@mui/icons-material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const CommentForm = ({ onSubmit, isSubmitting = false }) => {
  const [comment, setComment] = useState({
    firstName: "",
    lastName: "",
    text: "",
  });
  const [captchaValid, setCaptchaValid] = useState(false);
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const recaptchaRef = useRef(null);

  const handleChange = (e) => {
    setComment({ ...comment, [e.target.name]: e.target.value });
  };

  const handleCaptchaChange = (value) => {
    setCaptchaValid(!!value); // Se il valore esiste, il CAPTCHA è valido
  };

  const isFormValid =
    comment.firstName.trim() &&
    comment.lastName.trim() &&
    comment.text.trim() &&
    captchaValid &&
    privacyAccepted;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isFormValid) {
      onSubmit(comment); // Funzione per salvare il commento
      setComment({ firstName: "", lastName: "", text: "" }); // Reset campi
      setCaptchaValid(false); // Reset CAPTCHA
      if (recaptchaRef.current) {
        recaptchaRef.current.reset();
      }
    }
  };

  //6Le-yO0qAAAAAD12EGhpEmxn9BnkvpGlqu4zQcU6

  return (
    <Paper
      elevation={0}
      sx={{
        maxWidth: 800,
        mx: "auto",
        p: 4,
        my: 6,
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
        backgroundColor: "background.paper",
      }}
    >
      <Typography
        variant="h6"
        component="h2"
        fontWeight={600}
        gutterBottom
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          color: "text.primary",
        }}
      >
        Lascia un commento
      </Typography>

      <Divider sx={{ my: 2 }} />

      <Box component="form" onSubmit={handleSubmit} noValidate>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Nome *"
              name="firstName"
              value={comment.firstName}
              onChange={handleChange}
              variant="outlined"
              disabled={isSubmitting}
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Cognome *"
              name="lastName"
              value={comment.lastName}
              onChange={handleChange}
              variant="outlined"
              disabled={isSubmitting}
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Il tuo commento *"
              name="text"
              value={comment.text}
              onChange={handleChange}
              variant="outlined"
              multiline
              rows={5}
              disabled={isSubmitting}
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
            />
          </Grid>

          <Grid item xs={12} display="flex" justifyContent="space-between">
            <FormControlLabel
              control={
                <Checkbox
                  checked={privacyAccepted}
                  onChange={(e) => setPrivacyAccepted(e.target.checked)}
                  color="primary"
                />
              }
              label={
                <Typography variant="body2">
                  <a
                    href="https://www.iubenda.com/privacy-policy/76810248"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Dichiaro di aver preso visione dell&apos;informativa sulla
                    privacy
                    <OpenInNewIcon
                      sx={{
                        fontSize: "1rem",
                        ml: 0.5,
                        verticalAlign: "middle",
                        position: "relative",
                        top: -1,
                      }}
                    />
                  </a>
                </Typography>
              }
            />
            <ReCAPTCHAComponent
              sitekey="6Le-yO0qAAAAAD12EGhpEmxn9BnkvpGlqu4zQcU6"
              onChange={handleCaptchaChange}
              ref={recaptchaRef}
              theme="light"
              style={{ marginBottom: "16px" }}
            />
          </Grid>

          <Grid item xs={12} display="flex" justifyContent="flex-end">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={!isFormValid || isSubmitting}
              size="large"
              endIcon={
                isSubmitting ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <SendIcon />
                )
              }
              sx={{
                borderRadius: 2,
                px: 4,
                py: 1,
                textTransform: "none",
                fontWeight: 500,
                "&:hover": {
                  transform: "translateY(-1px)",
                  boxShadow: 2,
                },
                transition: "all 0.2s ease",
              }}
            >
              {isSubmitting ? "Invio in corso..." : "Invia commento"}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};

export default CommentForm;
